module.exports = __webpack_public_path__ + "static/Lime-05b2eb1d3cb89eae20ce57d327d70799.jpg";